import { Reveal } from "@/components/Reveal";
import { ImageDisclaimer } from "@/components/ImageDisclaimer";

export const About = () => (
  <section id="about" className="cp-section cp-section--cream" data-testid="about-section">
    <div className="cp-container cp-about-grid">
      <Reveal>
        <span className="cp-eyebrow">About Central Plaza</span>
        <h2 className="cp-h2">
          A Premium SCO Commercial Development, <em>Inside Buildaxis Township</em>
        </h2>
        <div className="cp-about-points">
          <p>
            Buildaxis Developers is developing <strong>2.705 acres</strong> of land in Sector 10A,
            Kharkhoda, Sonipat — a fully integrated township. Of this,{" "}
            <strong>1.196 acres</strong> is dedicated exclusively to the Central Plaza SCO
            Commercial Complex.
          </p>
          <p>
            Central Plaza commands more than an acre of frontage on the{" "}
            <strong>45-meter wide sector road</strong>, complemented by a{" "}
            <strong>12-meter service road</strong> — giving every unit exceptional visibility and
            excellent access for customers and deliveries alike.
          </p>
          <p>
            As Kharkhoda's first premium SCO complex, Central Plaza represents a rare, first-mover
            investment opportunity in one of NCR's most rapidly industrialising corridors.
          </p>
        </div>
        <div className="cp-about-stats">
          <div>
            <strong>2.705</strong>
            <span>Acre Township</span>
          </div>
          <div>
            <strong>1.196</strong>
            <span>Acre SCO Complex</span>
          </div>
          <div>
            <strong>16</strong>
            <span>Premium SCO Units</span>
          </div>
        </div>
      </Reveal>
      <Reveal delay={0.15} className="cp-about-image">
        <img
          src="/brochure/about-siteplan-aerial.png"
          alt="Central Plaza township aerial layout within Buildaxis development"
          loading="lazy"
        />
        <span className="cp-about-image-caption">Buildaxis Township — Master Layout</span>
        <ImageDisclaimer />
      </Reveal>
    </div>
  </section>
);
